import { Token, HouseholdIds } from './';

class Session {
  loggedIn: boolean;
  username: string = '';
  clientID: string = '';
  sviuserid: string = '';
  guid: string = '';
  orionToken: Token;
  householdIds: HouseholdIds;
  pspObjKey: string;
  processingInterstitials: boolean;

  constructor(
    loggedIn: boolean = false,
    username: string = '',
    clientID: string = '',
    sviuserid: string = '',
    guid: string = '',
    orionToken: Token = new Token(),
    householdIds: HouseholdIds = new HouseholdIds(),
    pspObjKey: string = '',
    processingInterstitials: boolean = false
  ) {
    this.loggedIn = loggedIn;
    this.username = username;
    this.clientID = clientID;
    this.sviuserid = sviuserid;
    this.guid = guid;
    this.orionToken = orionToken;
    this.householdIds = householdIds;
    this.pspObjKey = pspObjKey;
    this.processingInterstitials = processingInterstitials;
  }
}

export default Session;
